import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<IApiResponse<unknown>, IPathBaseParam, object>(
  "productPlans.deactive",
);

export const deactive = {
  ...postApis,
};
